import { type UseQueryResult, useQuery } from 'react-query';
import {
  TransferAgentIntegrationService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_TransferAgents_TransferAgentIntegrationDto,
} from '@wealthlane/api-services/wealthlane-award-service';

const useGetTransferAgentSetting = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_TransferAgents_TransferAgentIntegrationDto | undefined,
  unknown
> => {
  const transferAgentSetting = useQuery(['getTransferAgentSetting'], async () => {
    return await handleRequest(TransferAgentIntegrationService.getApiAwardApiAppTransferAgent());
  });

  return transferAgentSetting;
};

export default useGetTransferAgentSetting;
